import { Mary } from "@vwpfs/vwpfs-mary-react-comp-lib";
import React from "react";
import { SummaryProps } from "./Summary";

const formatPercentage = (value: number): string => value.toFixed(2).replace(".", ",") + " %";

export const SummarySubSection: React.FC<SummaryProps> = ({ result, loading, hasError }) => {
    if (hasError) {
        return null;
    }

    return (
        <>
            <Mary.base.Div className="scl-b-row">
                <Mary.base.Container
                    theme={{
                        padding: {
                            "": { y: 2, x: 3 },
                            "sm": { y: 3, x: 4 },
                        },
                    }}
                >
                    {loading ?
                        <Mary.atoms.loadingindicator.LoadingIndicator
                            type={Mary.atoms.loadingindicator.LoadingIndications.DEFAULT}
                            theme={{ palette: Mary.theme.ThemePalette.CONTRAST_PRIMARY }}
                        /> : (
                            <>
                                {(
                                    (!hasError &&
                                        result?.netCreditAmount &&
                                        result?.grossCreditAmount &&
                                        result?.interestRate &&
                                        result?.effectiveAnnualInterestRate)
                                    ||
                                    (!hasError && result?.netCreditAmount)
                                ) && (
                                    <div style={{ paddingTop: "6px" }}>
                                        <Mary.base.Div className="scl-b-row">
                                            {result?.netCreditAmount &&
                                                <Mary.base.Grid
                                                    size={{ xs: 12, md: 6 }}
                                                >
                                                    <div className="scl-o-form__summary-row--wrapper">
                                                        <span style={{ fontWeight: "bold" }}>
                                                            Totaal kredietbedrag
                                                        </span>
                                                        <Mary.atoms.currencyinput.CurrencyInput
                                                            amount={Number(result?.netCreditAmount)}
                                                            withoutDecimal withPrefix />
                                                    </div>
                                                </Mary.base.Grid>}
                                            {result?.grossCreditAmount &&
                                                <Mary.base.Grid
                                                    size={{ xs: 12, md: 6 }}
                                                >
                                                    <div className="scl-o-form__summary-row--wrapper">
                                                        <span style={{ fontWeight: "bold" }}>
                                                            Totaal te betalen bedrag
                                                        </span>
                                                        <Mary.atoms.currencyinput.CurrencyInput
                                                            amount={Number(result?.grossCreditAmount)}
                                                            withoutDecimal
                                                            withPrefix />
                                                    </div>
                                                </Mary.base.Grid>}
                                        </Mary.base.Div>
                                        <Mary.base.Div className="scl-b-row">
                                            {result.interestRate &&
                                                <Mary.base.Grid
                                                    size={{ xs: 12, md: 6 }}
                                                >
                                                    <div className="scl-o-form__summary-row--wrapper">
                                                        <span style={{ fontWeight: "bold" }}>
                                                            Debetrentevoet
                                                        </span>
                                                        <span>
                                                            {formatPercentage(Number(result?.interestRate))}
                                                        </span>
                                                    </div>
                                                </Mary.base.Grid>}
                                            {result.effectiveAnnualInterestRate &&
                                                <Mary.base.Grid
                                                    size={{ xs: 12, md: 6 }}
                                                >
                                                    <div className="scl-o-form__summary-row--wrapper">
                                                        <span style={{ fontWeight: "bold" }}>
                                                            Jaarlijks kostenpercentage
                                                        </span>
                                                        <span>
                                                            {formatPercentage(
                                                                Number(result?.effectiveAnnualInterestRate))}
                                                        </span>
                                                    </div>
                                                </Mary.base.Grid>}
                                        </Mary.base.Div>
                                    </div>
                                )}
                            </>)}
                </Mary.base.Container>
            </Mary.base.Div>
        </>
    );
};
